<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
  >
    <circle opacity="0.1" cx="32.5" cy="32.5" r="32.5" fill="#F57A4D" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.1606 43.046C23.3748 42.4927 22.6465 41.8632 21.9863 41.1684C22.3808 37.8324 26.3774 36.4551 32.4996 36.4551C38.6218 36.4551 42.6184 37.8324 43.0129 41.1684C42.3527 41.8632 41.6244 42.4927 40.8386 43.046H40.4087V41.7278C40.4087 40.1487 37.5823 39.0914 32.4996 39.0914C27.417 39.0914 24.5905 40.1487 24.5905 41.7278V43.046H24.1606Z"
      fill="#F57A4D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18 32.5C18 40.5081 24.4919 47 32.5 47C40.5081 47 47 40.5081 47 32.5C47 24.4919 40.5081 18 32.5 18C24.4919 18 18 24.4919 18 32.5ZM44.3628 32.5001C44.3628 39.0522 39.0513 44.3637 32.4992 44.3637C25.947 44.3637 20.6355 39.0522 20.6355 32.5001C20.6355 25.948 25.947 20.6365 32.4992 20.6365C39.0513 20.6365 44.3628 25.948 44.3628 32.5001ZM27.2271 29.8636C27.2271 26.9053 29.3086 24.5909 32.4998 24.5909C35.6821 24.5909 37.7725 27.1239 37.7725 30.1273C37.7725 34.4504 35.4236 36.4545 32.4998 36.4545C29.5482 36.4545 27.2271 34.3815 27.2271 29.8636ZM32.5008 33.8183C30.943 33.8183 29.8645 32.855 29.8645 29.8637C29.8645 28.3028 30.8317 27.2274 32.5008 27.2274C34.1033 27.2274 35.1372 28.4802 35.1372 30.1274C35.1372 32.8934 34.0533 33.8183 32.5008 33.8183Z"
      fill="#F57A4D"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style scoped></style>
